import { RootState } from 'store/rootReducer';
import { getContractBasedDataSelector } from '@cp-shared-19/frontend-integration';

export const UnpaidDetailsDataSelector = getContractBasedDataSelector((state: RootState) => state.unpaidDetails);
